import { Typography } from '@material-ui/core';
import { Box } from '@mui/material';
import styled, { css } from 'styled-components';

// Sharing these styles prevents the height of forms from shifting when an error occurs.
const sharedStyles = css`
    font-size: 12px;
    line-height: 1.2;
    margin-top: 6px;
`;

const StyledSubtext = styled(Typography)`
    ${sharedStyles};
    opacity: 0.8;
`;

const Error = styled(Box)`
    ${sharedStyles};
    color: ${(props) => props.theme.colors.error};
`;

export interface InputSubTextProps {
    id?: string;
    name?: string;
    errorMessage?: string;
    helperText?: string;
}

const InputSubText = (props: InputSubTextProps) => {
    const { id, name, errorMessage, helperText } = props;
    const testId = id ?? name;

    if (!testId) {
        return <></>;
    }

    if (errorMessage) {
        return (
            <Error role="alert" data-testid={`field_error_${testId}`}>
                {errorMessage}
            </Error>
        );
    }

    if (!helperText) {
        return <></>;
    }

    return <StyledSubtext data-testid={`helper_${testId}`}>{helperText}</StyledSubtext>;
};

export default InputSubText;
